// Only known signup hosts can hand an authenticated journey to Dashboard.
// Local staging is explicit in the signup Firebase project, never a query flag.
export const DASHBOARD_ROUTING_ERROR = 'Dashboard is unavailable on this signup host. Open the correct signup site to continue.';

export function resolveDashboardUrl({
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
  projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID,
  tenantId,
} = {}) {
  const stagingHosts = ['zedipass-staging.web.app', 'zedipass-staging.firebaseapp.com'];
  const productionHosts = ['zedipass.com', 'www.zedipass.com', 'zedipass.web.app', 'zedipass.firebaseapp.com'];
  const localHosts = ['localhost', '127.0.0.1', '[::1]'];
  let origin;
  if (stagingHosts.includes(hostname) ||
      (localHosts.includes(hostname) && projectId === 'zedipass-staging')) {
    origin = 'https://zedipass-dashboard-staging.web.app';
  } else if (productionHosts.includes(hostname) && projectId !== 'zedipass-staging') {
    origin = 'https://dashboard.zedipass.com';
  } else {
    return null;
  }
  // No arbitrary path, origin, redirect parameter or destination is accepted.
  return tenantId
    ? `${origin}/activation?tenantId=${encodeURIComponent(tenantId)}&step=overview`
    : `${origin}/`;
}
